export enum FilterField {
    Period = "period",
    Status = "status",
    Platforms = "platforms"
}
